import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AccountConfirmation } from '../../containers/account/AccountConfirmation';

export const AdminAccountConfirmationPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AccountConfirmation />
		</AdminDashboardPageLayout>
	);
};
